import React, { useEffect, useState, useRef, useCallback } from 'react'
import useApp from 'hooks/useApp'
import { Button, LayerBottom } from 'components'
import styles from './index.module.css'
import Graph from 'library/Graph'
import Snap from 'snapsvg-cjs'
import useEffectAvailable from 'hooks/useEffectAvailable'
import { useNavigate, useLocation } from 'react-router-dom'
import Lib from 'library'

const DataDetail = () => {

	const App = useApp()
	const location = useLocation()
	const mounted = useRef()
	const core = useRef()

	const [showLayer, setShowLayer] = useState(false)
	const [tabList, setTabList] = useState(0)
	const [dataOpen, setDataOpen] = useState(0)
	const [dataOpenM, setDataOpenM] = useState(2)
	const [detailView, setDetailView] = useState()
	const [crdtData, setCrdtData] = useState()
	const [sno, setSno] = useState(location.state?.sno)
	const [atBottom, setAtBottom] = useState(false)

	const { shareData } = useLocation() //공유한 증명서 데이터 받아오기

	const openLayer = () => setShowLayer(true)
	const closeLayer = () => setShowLayer(false)

	const bindScroll = () => {
		core.current = document.querySelector(".core")
		setTimeout(() => {
			if (core.current.clientHeight >= core.current.scrollHeight - 30) {
				!mounted.current && setAtBottom(true)
			}
		}, 300)
		core.current.addEventListener("scroll", e => {
			const clientHeight = core.current.clientHeight
			const scrollHeight = core.current.scrollHeight
			const scrollTop = core.current.scrollTop
			if (!mounted.current) return
			if (clientHeight + scrollTop >= scrollHeight - 30) {
				setAtBottom(true)
			} else {
				setAtBottom(false)
			}
		})
	}

	useEffect(() => {
		mounted.current = true
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")

		console.log(location.state)

		mounted.current && bindScroll()

		return () => mounted.current = false
	}, [])

	const monthIncrease = (data) => {
		let month;
		let nextMonth;
		let percentage;

		month = Number(data[1].yearSalary);
		nextMonth = Number(data[2].yearSalary);

		if (month === 0 || nextMonth === 0) {
			if (nextMonth === 0 && month > 0) {
				percentage = 100
			} else if (month === 0 && nextMonth > 0) {
				percentage = -100
			} else if (month === 0 || nextMonth === 0) {
				percentage = '0'
			}
		} else {
			const result = Math.round((nextMonth - month) / nextMonth * 100);
			if (result === 0) {
				percentage = '0'
			} else {
				percentage = result
			}
		}
		return percentage;
	}

	const crdGraph = (item, n) => {
		let average;
		let percentage;
		let total = 0;
		item.forEach(el => {
			total += Number(el.yearSalary)
		});
		average = Math.floor(total / 3)
		percentage = Math.floor((average / total) * 100)
		if (n === 1) {
			return average
		} else if (n === 2) {
			return percentage
		} else {
			return total;
		}
	}

	useEffect(() => {

		Lib.post(`/api/data/crtf/review`, {
			carYn: location.state?.carYn,
			crdtYn: location.state?.crdtYn,
			houseYn: location.state?.houseYn,
			incmYn: location.state?.incmYn,
			mdataYn: location.state?.mdataYn

		}, data => {
			console.log('data : ' + JSON.stringify(data));

			// 마이데이터 탭 포커싱 처리. 20221028
			if (Lib.isNotNull(data) && Lib.isNotNull(data.mdataDtl)) {
				if (data.mdataDtl.acntBlncAmt !== null || data.mdataDtl.acntLoanBlncAmt !== null || data.mdataDtl.acntInvstEvalAmt !== null) {
					setTabList(0)
				} else if (data.mdataDtl.cardPayExpAmt !== null || data.mdataDtl.cardPrpymBlncAmt !== null || data.mdataDtl.cardLoanBlncAmt !== null) {
					setTabList(1)
				} else if (data.mdataDtl.insuMthAvrgPymnt !== null || data.mdataDtl.insuLoanBlncAmt !== null) {
					setTabList(2)
				} else if (data.mdataDtl.sabInvstEvalAmt !== null) {
					setTabList(3)
				} else if (data.mdataDtl.ebankPayAmt !== null || data.mdataDtl.ebankPayBlncAmt !== null) {
					setTabList(4)
				} else if (data.mdataDtl.cmnctBlngAmt !== null) {
					setTabList(5)
				} else if (data.mdataDtl.irpBankAcntBlncAmt !== null || data.mdataDtl.irpInsuAcntBlncAmt !== null || data.mdataDtl.irpSabAcntBlncAmt !== null) {
					setTabList(6)
				} else if (data.mdataDtl.gnteeInsuTotalPymntAmt !== null) {
					setTabList(7)	
				} else if (data.mdataDtl.instlFincLoanBlncAmt !== null) {
					setTabList(8)
				} else if (data.mdataDtl.bondLoanBlncAmt !== null) {
					setTabList(9)
				} else if (data.mdataDtl.p2pLoanBlncAmt !== null) {
					setTabList(10)
				}
			}

			setDetailView(data);

			// setCrdtData({
			// average: crdGraph(data.incmDtl.lstIncm, 1),
			// percentage: crdGraph(data.incmDtl.lstIncm, 2),
			// total: crdGraph(data.incmDtl.lstIncm, 3),
			//monthinc : monthIncrease(data.incmDtl.lstIncm),
			//incNumber : Math.ceil((data.incmDtl.lstIncm[2].yearSalary / data.incmDtl.lstIncm[0].yearSalary -1 ) * 100)
			// })
		});
	}, [])


	// DataPwSetting.js 에서 공유하기 네이티브 호출함

	const mothYearChange = (item) => {
		let year = Math.floor(item / 12) > 0 ? Math.floor(item / 12) + '년 ' : '';
		let month = (item % 12) > 0 ? (item % 12) + '개월' : '';
		return year + month
	}

	return (
		<div className="page pb_100">
			<div className="shadow">
				<div className="padding">
					{location.state?.avlDt &&
						<AlarmComponent detail={location.state} />
					}
					{/* <div className={`${styles["time-box"]} mt_10`}>
                        <span>열람가능 시간</span>
                        <strong className="ml_10">
                            <span>D-4</span>
                            <span className="ml_5">17:32:22</span>
                        </strong>
                    </div> */}

					<div className="flex-justify_between">

						<h4>{`${App.user?.mbNm}님의`}<br /><strong>데이터 증명서</strong></h4>
						<span style={{ color: "#999", fontWeight: 500 }}>일련번호 No. {sno ? sno : detailView && detailView.sno}</span>
					</div>
				</div>
			</div>

			{/* 신용정보 */}
			{(location.state?.crdtYn === "Y") && detailView?.crdtDtl &&
				<div className="shadow">
					<div className={`${dataOpen === 0 ? "active" : ""} accordion-title flex-justify_between align_center padding`}
						onClick={() => {
							if (dataOpen === 0) {
								setDataOpen()
							} else {
								setDataOpen(0)
							}
						}}>
						<h3>신용정보</h3>
						<i className="icon icon_accordion_arrow" />
					</div>
					<div className="accordion-content padding pt_0">
						<p className={styles["info-title"]}>
							{`${App.user?.mbNm}`}님의 점수는 <strong className="text-blue">{detailView && detailView.crdtDtl.score}</strong>으로<br />
							<strong>상위 {detailView && detailView.crdtDtl.rt}%</strong>에 있네요!
						</p>

						{/* 그래프 영역 */}
						<div style={{ width: "22rem", height: "20rem", margin: "0 auto" }}>
							{/* {dataOpen === 0 && detailView &&
                                sno ?
                                <MainGraph data={location.state?.crdtDtl?.score} crdtRt={location.state?.crdtDtl?.rt} score={location.state?.crdtDtl?.score} />
                                :
                                <MainGraph data={detailView?.crdtDtl?.score} crdtRt={detailView?.crdtDtl?.rt} score={detailView?.crdtDtl?.score} />
                            } */}
							{dataOpen === 0 && location.state?.crdtYn === "Y" && <MainGraph data={detailView?.crdtDtl?.score} crdtRt={detailView?.crdtDtl?.rt} score={detailView?.crdtDtl?.score} />}
						</div>

						<hr className="my_40" />

						<p className={`${styles["info-sub-title"]} mt_40`}>
							{detailView?.crdtDtl?.ageGrp}대 평균 보다 {`${App.user?.mbNm}`}님의<br />점수가
							{detailView &&
								detailView.crdtDtl.score - detailView.crdtDtl.ageGrpScore >= 0 ?
								<strong className="text-blue">&nbsp;{detailView && detailView.crdtDtl.score - detailView.crdtDtl.ageGrpScore}점 더 높아요!</strong>
								:
								<strong className="text-blue">&nbsp;{detailView && detailView.crdtDtl.ageGrpScore - detailView.crdtDtl.score}점 더 낮아요!</strong>
							}

						</p>

						{detailView && detailView?.crdtDtl?.score === 0 ?
							<div className="mt_30 pb_50 progress-wrap">
								<span className="flex-shrink_0">{detailView.crdtDtl.ageGrp}대</span>ageGrp
								<div className="data-progress flex--item_1 ml_15">
									<div className="progress" style={{ width: 0 }}>
										<div className="txt">
											<span className="ml_10" style={{ color: "#999", whiteSpace: "nowrap" }}>나<span className="ml_5" style={{ color: "#57a7fb" }}>0점</span></span>
										</div>
									</div>
									<span className="floating-num" style={{ left: (detailView.crdtDtl.ageGrpScore / 1000) * 100 + '%' }}>평균 {detailView.crdtDtl.ageGrpScore}점</span>
								</div>
							</div>
							: detailView?.crdtDtl?.score > 0 &&
							<div className="mt_30 pb_50 progress-wrap">
								<span className="flex-shrink_0">{detailView && detailView.crdtDtl.ageGrp}대</span>
								<div className="data-progress flex--item_1 ml_15">
									<div className="progress" style={{ width: (detailView && detailView.crdtDtl.score / 1000) * 100 + '%' }}>
										<div className="txt">
											<span>나</span>
											<span>{detailView && detailView.crdtDtl.score}점</span>
										</div>
									</div>
									<span className="floating-num" style={{ left: (detailView && detailView.crdtDtl.ageGrpScore / 1000) * 100 + '%' }}>평균 {detailView && detailView.crdtDtl.ageGrpScore}점</span>
								</div>
							</div>
						}
					</div>
				</div>
			}

			{/* 소득정보 */}
			{/* <div className="shadow">
                <div className={`${dataOpen === 1 ? "active" : ""} accordion-title flex-justify_between align_center padding`} onClick={() => setDataOpen(1)}>
                    <h3>소득정보</h3>
                    <i className="icon icon_accordion_arrow" />
                </div>
                <div className="accordion-content padding pt_0">
                    <p className={styles["info-title"]}>직장정보</p>
                    {detailView && detailView.incmDtl.lstJageok.map((item,index)=> {
                        return (
                            <ul key={index} className={`${styles["job-info"]} mt_20`}>
                                <li className={styles.title}>
                                    <span>{item.corpNm}</span>
                                    <span className="text-blue">{mothYearChange(item.workPrd)}</span>
                                </li>
                                <li>
                                    <span>{item.issueDt} ~ {item.lossDt}</span>
                                    <span>{item.lossDt === '' ? '재직중':''}</span>
                                </li>
                            </ul>
                        )
                    })}
                    <hr className="my_40" />
                    <p className={styles["info-title"]}>올해 소득은 작년대비<br /><strong className="text-blue">{crdtData && crdtData.monthinc}% 상승</strong>했어요!</p>
                    <div className="mt_20" style={{ color: "#666" }}>최근 3년동안 소득 <strong>인상률 평균은 {crdtData && crdtData.incNumber}%</strong>에요.<br />
                        * 평균 {crdtData && crdtData.average}만원</div>

                    <div className="mt_50">
                        <div className={`${styles["drag-head"]}`}>
                            <div className={styles["bar-graph"]}>
                                <ul className={styles.graph}>
                                    
                                    {detailView && detailView.incmDtl.lstIncm.map((item,index)=> {
                                        if (crdtData === undefined){return false}
                                        return (
                                            <li key={index} className={index === 2 && styles.today} >
                                                <div className='mb_10' style={{fontSize: '1.2rem'}}>{item.yearSalary}만원</div>
                                                <div className={styles.bar}>
                                                    <span style={{ height: (item.yearSalary / crdtData.total) * 100 +'%'}} />
                                                </div>
                                                <span>{item.year}</span>
                                            </li>
                                        )
                                    })}
                                </ul>
                                {crdtData && (
                                    <div className={styles.average} style={{ bottom: ((8 * crdtData.percentage) /100) + "rem" }}>
                                        <span>평균<br/>{crdtData.average}만원</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

			{/* 마이데이터 */}
			{(location.state?.mdataYn === "Y") && detailView?.mdataDtl &&
				<div className="shadow">
					<div className={`${dataOpenM === 2 ? "active" : ""} accordion-title flex-justify_between align_center padding`}
						onClick={() => {
							if (dataOpenM === 2) {
								setDataOpenM()
							} else {
								setDataOpenM(2)
							}
						}}>
						<h3>마이데이터</h3>
						<i className="icon icon_accordion_arrow" />
					</div>
					<div className="accordion-content">
						<div className="no-scroll" style={{ overflowX: "auto" }}>
							<ul className="tab-scroll">
								{detailView && (detailView.mdataDtl.acntBlncAmt !== null || detailView.mdataDtl.acntLoanBlncAmt !== null || detailView.mdataDtl.acntInvstEvalAmt !== null) &&
									<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>은행</li>
								}
								{detailView && (detailView.mdataDtl.cardPayExpAmt !== null || detailView.mdataDtl.cardPrpymBlncAmt !== null || detailView.mdataDtl.cardLoanBlncAmt !== null) &&
									<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>카드</li>
								}
								{detailView && (detailView.mdataDtl.insuMthAvrgPymnt !== null || detailView.mdataDtl.insuLoanBlncAmt !== null) &&
									<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>보험</li>
								}
								{detailView && detailView.mdataDtl.sabInvstEvalAmt !== null &&
									<li onClick={() => setTabList(3)} className={tabList === 3 ? "active" : ""}>증권</li>
								}
								{detailView && (detailView.mdataDtl.ebankPayAmt !== null || detailView.mdataDtl.ebankPayBlncAmt !== null) &&
									<li onClick={() => setTabList(4)} className={tabList === 4 ? "active" : ""}>전자금융</li>
								}
								{detailView && detailView.mdataDtl.cmnctBlngAmt !== null &&
									<li onClick={() => setTabList(5)} className={tabList === 5 ? "active" : ""}>통신</li>
								}
								{detailView && (detailView.mdataDtl.irpBankAcntBlncAmt !== null || detailView.mdataDtl.irpInsuAcntBlncAmt !== null || detailView.mdataDtl.irpSabAcntBlncAmt !== null) &&
									<li onClick={() => setTabList(6)} className={tabList === 6 ? "active" : ""}>개인IRP</li>
								}
								{detailView && detailView.mdataDtl.gnteeInsuTotalPymntAmt !== null &&
									<li onClick={() => setTabList(7)} className={tabList === 7 ? "active" : ""}>보증보험</li>
								}
								{detailView && detailView.mdataDtl.instlFincLoanBlncAmt !== null &&
									<li onClick={() => setTabList(8)} className={tabList === 8 ? "active" : ""}>할부금융</li>
								}
								{detailView && detailView.mdataDtl.bondLoanBlncAmt !== null &&
									<li onClick={() => setTabList(9)} className={tabList === 9 ? "active" : ""}>인수채권/대부</li>
								}
								{detailView && detailView.mdataDtl.p2pLoanBlncAmt !== null &&
									<li onClick={() => setTabList(10)} className={tabList === 10 ? "active" : ""}>P2P</li>
								}
							</ul>
						</div>

						{detailView && (

							tabList === 0 ? // 은행 Lib.isNull(blncAmtOrder)
								<ul className={`${styles["mydata-list"]} padding`}>
									<li>
										<span>계좌 잔액</span>
										<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.acntBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.acntBlncAmt)}</strong>원</span>
									</li>
									<li>
										<span>남은 대출금</span>
										<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.acntLoanBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.acntLoanBlncAmt)}</strong>원</span>
									</li>
									<li>
										<span>투자평가금액</span>
										<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.acntInvstEvalAmt) ? 0 : Lib.addComma(detailView.mdataDtl.acntInvstEvalAmt)}</strong>원</span>
									</li>
								</ul>

								: tabList === 1 ? // 카드
									<ul className={`${styles["mydata-list"]} padding`}>
										<li>
											<span>{detailView.mdataDtl.cardPayMth}월 결제예정금액</span>
											<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.cardPayExpAmt) ? 0 : Lib.addComma(detailView.mdataDtl.cardPayExpAmt)}</strong>원</span>
										</li>
										<li>
											<span>선불카드 총 잔액</span>
											<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.cardPrpymBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.cardPrpymBlncAmt)}</strong>원</span>
										</li>
										<li>
											<span>대출 잔액</span>
											<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.cardLoanBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.cardLoanBlncAmt)}</strong>원</span>
										</li>
									</ul>

									: tabList === 2 ? // 보험
										<ul className={`${styles["mydata-list"]} padding`}>
											<li>
												<span>월평균납입보험료</span>
												<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.insuMthAvrgPymnt) ? 0 : Lib.addComma(detailView.mdataDtl.insuMthAvrgPymnt)}</strong>원</span>
											</li>
											<li>
												<span>남은 대출금</span>
												<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.insuLoanBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.insuLoanBlncAmt)}</strong>원</span>
											</li>
										</ul>

										: tabList === 3 ? // 증권
											<ul className={`${styles["mydata-list"]} padding`}>
												<li>
													<span>투자평가금액</span>
													<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.sabInvstEvalAmt) ? 0 : Lib.addComma(detailView.mdataDtl.sabInvstEvalAmt)}</strong>원</span>
												</li>
											</ul>

											: tabList === 4 ? // 전자금융
												<ul className={`${styles["mydata-list"]} padding`}>
													<li>
														<span>{detailView.mdataDtl.ebankPayMth}월 결제 총액</span>
														<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.ebankPayAmt) ? 0 : Lib.addComma(detailView.mdataDtl.ebankPayAmt)}</strong>원</span>
													</li>
													<li>
														<span>페이 총 잔액</span>
														<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.ebankPayBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.ebankPayBlncAmt)}</strong>원</span>
													</li>
												</ul>

												: tabList === 5 ? // 통신
													<ul className={`${styles["mydata-list"]} padding`}>
														<li>
															<span>{detailView.mdataDtl.cmnctBlngMth}월 청구금액</span>
															<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.cmnctBlngAmt) ? 0 : Lib.addComma(detailView.mdataDtl.cmnctBlngAmt)}</strong>원</span>
														</li>
													</ul>

													: tabList === 6 ? // 개인IRP
														<ul className={`${styles["mydata-list"]} padding`}>
															<li>
																<span>은행 계좌 잔액</span>
																<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.irpBankAcntBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.irpBankAcntBlncAmt)}</strong>원</span>
															</li>
															<li>
																<span>보험 계좌 잔액</span>
																<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.irpInsuAcntBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.irpInsuAcntBlncAmt)}</strong>원</span>
															</li>
															<li>
																<span>증권 계좌 잔액</span>
																<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.irpSabAcntBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.irpSabAcntBlncAmt)}</strong>원</span>
															</li>
														</ul>

														: tabList === 7 ? // 보증보험
															<ul className={`${styles["mydata-list"]} padding`}>
																<li>
																	<span>총납입보험료</span>
																	<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.gnteeInsuTotalPymntAmt) ? 0 : Lib.addComma(detailView.mdataDtl.gnteeInsuTotalPymntAmt)}</strong>원</span>
																</li>
															</ul>

															: tabList === 8 ? // 할부금융
																<ul className={`${styles["mydata-list"]} padding`}>
																	<li>
																		<span>대출잔액</span>
																		<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.instlFincLoanBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.instlFincLoanBlncAmt)}</strong>원</span>
																	</li>
																</ul>

																: tabList === 9 ? // 인수채권/대부
																	<ul className={`${styles["mydata-list"]} padding`}>
																		<li>
																			<span>대출잔액</span>
																			<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.bondLoanBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.bondLoanBlncAmt)}</strong>원</span>
																		</li>
																	</ul>

																	: tabList === 10 ? // P2P
																		<ul className={`${styles["mydata-list"]} padding`}>
																			<li>
																				<span>대출잔액</span>
																				<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(detailView.mdataDtl.p2pLoanBlncAmt) ? 0 : Lib.addComma(detailView.mdataDtl.p2pLoanBlncAmt)}</strong>원</span>
																			</li>
																		</ul>
																		: null
						)}

					</div>
				</div>
			}
			{/* 자동차 */}
			{/* <div className="shadow">
                <div className={`${dataOpen === 3 ? "active" : ""} accordion-title flex-justify_between align_center padding`} onClick={() => setDataOpen(3)}>
                    <h3>자동차</h3>
                    <i className="icon icon_accordion_arrow" />
                </div>
                <div className="accordion-content padding pt_0">
                    <p className={styles["info-title"]}>차량정보</p>
                    <div className="slider mt_40">
                        <ul>
                            <li>
                                <div className="img-box mt_40" style={{ width: "30rem", height: "13.6rem", margin: "0 auto" }}>
                                    <img src={carImg} alt="" />
                                </div>
                                <span className="license-plate mt_35">245 무 1245</span>
                                <div className="car-info mt_20">
                                    <div>
                                        <span>테슬라</span>
                                        <span>테슬라 모델X</span>
                                    </div>
                                    <p>조대리님 미래 2058년의 차 테슬라 모델X</p>
                                </div>
                                <div className="car-price mt_10"><strong className="text-blue">13,800</strong> 만원</div>
                                <ul className="my-info-box mt_30">
                                    <li>
                                        <span>미납</span>
                                        <span className="text-red">통행료 미납</span>
                                    </li>
                                    <li>
                                        <span>보험</span>
                                        <span className="text-red">만기 D-30</span>
                                    </li>
                                    <li>
                                        <span>검사</span>
                                        <span style={{ color: "#333" }}>만기 D-123</span>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul className="slider-dots dots-gray" style={{ position: "absolute", right: 0, top: "-6rem" }}>
                            <li className="active" />
                            <li />
                            <li />
                        </ul>
                    </div>
                </div>
            </div> */}

			{/* 집 */}
			{/* <div className="shadow">
                <div className={`${dataOpen === 4 ? "active" : ""} accordion-title padding`} onClick={() => setDataOpen(4)}>
                    <div className="flex-justify_between align_center">
                        <h3>집</h3>
                        <i className="icon icon_accordion_arrow" />
                    </div>
                </div>
                <div className="accordion-content">
                    <p className={`${styles["info-title"]} padding pt_0 pb_0`}>부동산 정보</p>
                    <ul className="estate-list list-bg pb_40">
                        {detailView && detailView.lstHouseDtl.map((item,index)=> {
                            return (
                                <li key={index}>
                                    <p>{item.nm}</p>
                                    <div className="flex-justify_between align_center">
                                        <div className="estate-info">
                                            <span>{item.clsfc}</span>
                                            <span>{item.typ}</span>
                                        </div>
                                        <strong>{Lib.numberToKorean(item.qut)}원</strong>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div> */}

			<div className="padding py_30">
				<p style={{ fontSize: "1.6rem" }}>이 증명서는 원본 내용과 틀림없음을 증명합니다.</p>
				<div className="text-align_center mt_40">
					<p style={{ color: "#666" }}>{Lib.dateFormat(Lib.getToDate(), ".")}<br />주식회사 핀테크(모니)</p>
				</div>
				{/* <Button className="btn btn--big mt_40" onClick={openLayer}>증명서 공유하기</Button> */}
			</div>

			<div className="btn--fixed padding">
				{/* <div className="flex-justify_center mb_20">
					<span className={styles.guide}><i className="icon icon_floating_arrow_down mr_5" />끝까지 확인하고 동의하기</span>
				</div> */}
				<Button className="btn btn--big" onClick={openLayer}>증명서 공유하기</Button>
			</div>

			{detailView && <TermsLayer show={showLayer} closeLayer={closeLayer} sno={detailView.sno} />}
		</div>
	)
}

const AlarmComponent = ({ detail }) => {

	const [day, setDay] = useState();
	const [timeRender, setTimeRender] = useState();
	const [dis, setDis] = useState();
	const timer = useRef(null);
	const dt = detail?.avlDt

	const getDay = (dt, set) => {
		const setDate = new Date(dt);
		// setDate.setHours(23, 59, 59);
		const now = new Date();
		const distance = setDate.getTime() - now.getTime();

		const day = Math.floor(distance / (1000 * 60 * 60 * 24));
		const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((distance % (1000 * 60)) / 1000);

		setDay(day)
		setTimeRender(`${hours}:${minutes}:${seconds}`)
	}

	useEffect(() => {
		getDay(dt)
		timer.current = setInterval(() => getDay(dt), 1000)
		return () => clearInterval(timer.current)
	}, [dt])

	//console.log(dt)

	return (
		<div className={`${styles["time-box"]} mb_30`}>
			<span>열람가능 시간</span>
			<strong className="ml_10">
				<span>{`D-${day}`}</span>
				<span className="ml_5">{timeRender}</span>
			</strong>
		</div>
	)
}

const TermsLayer = ({ show, closeLayer, sno }) => {
	const [termsChecked, setTermsChecked] = useState(false)
	const [disabled, setDisabled] = useState(true)
	const onTerms = useCallback(({ target }) => setTermsChecked(target.checked), [])
	const navigate = useNavigate()
	const onRouterCallback = useCallback(() => {
		navigate("/home/dataPwSetting", { state: { sno } })
		closeLayer()
	}, [])

	useEffect(() => {
		if (termsChecked) setDisabled(false)
		else setDisabled(true)
	}, [termsChecked])

	return (
		<LayerBottom show={show} closeLayer={closeLayer} outside={
			<div className="button-group">
				<Button disabled={disabled} className="btn btn--big btn-layer" onClick={onRouterCallback}>동의</Button>
			</div>
		}>
			<div>
				<div className="chk">
					<input type="checkbox" checked={termsChecked} onChange={onTerms} id="check1" name="agree" />
					<label htmlFor="check1">
						<span><strong>[필수]</strong> 정보 공유 동의</span>
					</label>
				</div>
				<div className="layer-text mt_30">
					<p>
						공유 서비스는 개인이 본인의 정보를 직접 선택하여 공유하고자 하는 사람에게 제공하는 서비스 이며, 이에 관한 관리 책임은 이용자 본인에게 있어요.
					</p>
					<p className="mt_20">
						서비스 이용상의 과실 또는 제 3자에 의한 부정사용 등으로 인해 발생하는 모든 불이익에 대해 회사는 이에 책임을 지지 않아요. 다만, 회사의 고의 또는 과실에 의한 경우는 제외되어요.
					</p>
				</div>
			</div>
		</LayerBottom>
	)
}

// 메인 원 그래프
const MainGraph = ({ data, crdtRt, score }) => {

	const svg = useRef()

	const draw = () => {
		svg.current?.closest(".loading")?.classList.remove("loading")
		const paper = Snap(svg.current)

		const { width, height } = svg.current.getBoundingClientRect()
		const cx = width / 2
		const cy = height / 2
		const radius = width / 2 * 0.8

		const pieGroup = paper.g({ name: "pieGroup" })

		const filter = paper.filter(Snap.filter.shadow(0, 3, 6, "#000", 0.3))

		const percentage = score / 1000 * 100

		//const _crdtRt = Number(crdtRt).toFixed(0);
		//const percentage = _crdtRt;

		const angle = 240 * (Number(percentage) / 100) === 360 ? 359.9 : 240 * (Number(percentage) / 100)

		console.log(`percentage: ${percentage}`)
		console.log(`angle: ${angle}`)

		let d = Graph.describeArc(cx, cy, radius, -120, -120)

		const bgPath = paper.path(d).attr({
			stroke: "#efefef",
			strokeWidth: 10,
			fill: "none",
			strokeLinecap: "round",

		}).appendTo(pieGroup)

		const path = paper.path(d).attr({
			stroke: "#298CFA",
			strokeWidth: 9,
			fill: "none",
			strokeLinecap: "round",

		}).appendTo(pieGroup)

		bgPath.attr("d", Graph.describeArc(cx, cy, radius, -120, 120))

		const circle2 = pieGroup.circle(cx, cy, 0).attr({
			fill: "white",
			filter: filter
		})

		// setTimeout(() => {
		//  circle2.animate({
		//      r: width / 2 * 0.63
		//  }, 500, window.mina.backout)
		// }, 1500)

		// setTimeout(() => {
		//  circle1.animate({
		//      r: width / 2 * 0.85
		//  }, 500, window.mina.backout)
		// }, 1500)

		setTimeout(() => {
			circle2.animate({
				r: width / 2 * 0.63
			}, 500, window.mina.backout)
		}, 1500)

		let ease = window.mina.backout
		if (data > 90) ease = window.mina.easeout

		//path.attr("d", Graph.describeArc(cx, cy, radius, -120, ( 3 - 120 )))

		setTimeout(() => {
			Snap.animate(0, angle, value => {
				path.attr("d", Graph.describeArc(cx, cy, radius, -120, (value - 120)))
			}, 700, ease)
		}, 2100)

		const text = paper.text(cx, cy, [score, "점", `상위 ${crdtRt}%`]).attr({
			fill: "#298CFA",
			fontSize: "3rem",
			textAnchor: "middle",
			alignmentBaseline: "middle",
			fontWeight: 600,
			opacity: 0
		})

		text.children()[1].attr({
			fill: "#333",
			dx: 2,
			fontWeight: 500,
			fontSize: "1.6rem"
		})

		text.children()[2].attr({
			fill: "#fff",
			x: cx,
			dy: 27,
			fontWeight: 600,
			fontSize: "1.4rem"
		})

		setTimeout(() => {
			const bbox = text.getBBox()
			text.animate({
				y: bbox.cy,
				opacity: 1
			}, 500, window.mina.easeinout)
		}, 3000)

		const text_v2 = paper.text(cx, cy, "0").attr({
			fill: "#333",
			fontSize: "1.2rem",
			fontWeight: 400,
		})

		const text_v3 = paper.text(cx, cy, "1000").attr({
			fill: "#333",
			fontSize: "1.2rem",
			fontWeight: 400,
		})

		text_v2.attr({
			x: '3rem',
			y: '17.5rem'
		})

		text_v3.attr({
			x: '17rem',
			y: '17.5rem'
		})

		const rect = pieGroup.rect('50%', "50%", 75, 25, 12, 12).attr({
			transform: "translate(-35.5, 10)",
			fill: "#298CFA",
			opacity: 0
		});

		setTimeout(() => {
			rect.animate({
				opacity: 1,
			}, 500, window.mina.backout)
		}, 3000)
	}

	useEffectAvailable(draw, [data])

	return (
		<div className="mt_30 loading" style={{ width: "21.5rem", height: "21.5rem" }}>
			<svg ref={svg} style={{ height: "100%", width: "100%" }} />
		</div >
	)
}

export default DataDetail

